<template lang="pug">
  y-dialog(v-if="showModal" v-model="showModal" scrollable max-width='600px' persistent)
    v-card
      v-card-title.px-4
        div.h6.basic800--text {{ $t('edit_products_inventory') }}
      v-divider.basic300
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      template(v-else)
        v-card-text.px-4.pt-4.pb-0
          v-form(ref="form")
            v-radio-group.mt-n2(v-model='showProductInventory' row dense hide-details)
              v-radio(label='Hidden', value='hidden')
                template(v-slot:label)
                  div.p1.textColorDefault--text {{ $t('hidden') }}
              v-radio(label='Always', value='always')
                template(v-slot:label)
                  div.p1.textColorDefault--text {{ $t('always') }}
              v-radio(label='Only when low', value='low')
                template(v-slot:label)
                  div.p1.textColorDefault--text {{ $t('only_when_low') }}
            
      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = false')
          .button-Aa-small.primary400--text {{ $t('cancel') }}
        v-btn.mr-2(color='textColorAccent' dark depressed height=32 @click="clickSave()" :loading="isLoading")
          .button-AA-small.basic100--text {{ $t('save') }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'EditProductsInventoryVisibility',
  props: ['open', 'company', 'settings'],
  data: () => ({
    isFetching: false,
    showProductInventory: 'hidden',
    isLoading: false,
  }),
  mounted () {
    if (this.settings.show_stock_level) {
      this.showProductInventory = 'always'
    } else if (this.settings.show_stock_level_when_low) {
      this.showProductInventory = 'low'
    }
  },
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSave() {
      this.isLoading = true
      const params = {}
      if (this.showProductInventory === 'always') {
        params.show_stock_level = true
        params.show_stock_level_when_low = false
      } else if (this.showProductInventory === 'low') {
        params.show_stock_level = false
        params.show_stock_level_when_low = true
      } else {
        params.show_stock_level = false
        params.show_stock_level_when_low = false
      }
      this.$axios.patch(`/store/settings/${this.company.slug}/`, params)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.visibility_updated')])
          this.$emit('update:settings', { ...this.settings, show_stock_level: params.show_stock_level, show_stock_level_when_low: params.show_stock_level_when_low,  })
          this.showModal = false
        })
        .catch(() =>{
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "edit_products_inventory": "Edit products inventory visibility",
    "hidden": "Hidden",
    "always": "Always",
    "only_when_low": "Only when low"
  },
  "id": {
    "edit_products_inventory": "Edit tampilan inventaris produk",
    "hidden": "Sembunyi",
    "always": "Selalu",
    "only_when_low": "Hanya saat rendah"
  }
}
</i18n>
